var styles = {"box":"Additional_box_e071q_1","v1":"Additional_v1_e071q_4","v2":"Additional_v2_e071q_21","top":"Additional_top_e071q_43","amount":"Additional_amount_e071q_61"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
